import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ImageformatServiceConfig = {
  name: "Imageformat",
  annotations: []
} as ServiceConfig;